module.exports = __webpack_public_path__ + "media/images/font/Gustavo-Medium-346229abbf687464c16a9f83d195c5a3.eot";